import { render, staticRenderFns } from "./PolicyStatus.vue?vue&type=template&id=2bfa9550"
import script from "./PolicyStatus.vue?vue&type=script&lang=js"
export * from "./PolicyStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports